var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-bd tb",staticStyle:{"padding":"0"}},[_c('custom-tab',{attrs:{"list":_vm.tabList},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}}),(_vm.tabIndex === '1')?_c('location'):_vm._e(),(_vm.tabIndex === '2')?_c('site'):_vm._e(),(_vm.tabIndex === '3')?_c('plan'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }